import {
  getPropDefaultsBase
} from "./chunk-76FQY6HX.js";
import {
  typographyStyles
} from "./chunk-BU6N4DJ3.js";
import {
  applyTypography
} from "./chunk-XBZNPA3L.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/base/LabelModerate.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
function LabelModerateString(props) {
  const _a = getPropDefaults(props), { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ jsx(StyledLabelModerate, __spreadProps(__spreadValues({}, rest), { children }));
}
function getPropDefaults(props) {
  return getPropDefaultsBase(props, { as: props.tag || "span" });
}
var StyledLabelModerate = styled.span`
  ${({ theme, size, colorProp }) => applyTypography(theme, "Label Moderate", size, colorProp)}
  ${typographyStyles}
`;

export {
  LabelModerateString,
  getPropDefaults,
  StyledLabelModerate
};
